import React, { useState, useEffect, useRef } from "react";
import MainModal from "components/ModalMain";
import Button from "components/Button";
import Input from "components/Input";
import DatePicker from "components/DatePicker";
import Checkbox from "components/Checkbox";
import TextArea from "components/TextArea";
import TextTooltip from "./TextTooltip"
import { useMutation } from "@apollo/client";
import { CREATE_COUPON } from "graphql/service";
import { Head, Container, InputRow, Footer } from "./styles";
import colors from "constants/colors";
import moment from "moment-timezone";
import { TIME_ZONE } from "constants/constant";

const ModalAddCoupon = ({
  hidden,
  buttonStyle,
  setCoupons
}) => {
  const inputRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus()
        }
      }, 50)
      return () => clearTimeout(timer)
    }
  }, [isOpen])

  const [couponCode, setCouponCode] = useState("");
  const [couponCodeError, setCouponCodeError] = useState(false);

  const [discountAmount, setDiscountAmount] = useState("");
  const [discountAmountError, setDiscountAmountError] = useState(false);

  const [startDate, setStartDate] = useState(moment().tz(TIME_ZONE));
  const [endDate, setEndDate] = useState(
    moment().tz(TIME_ZONE).add(1, "days")
  );

  const [couponExpires, setCouponExpires] = useState(true);

  const [description, setDescription] = useState("");
  const [descriptionError, setDescriptionError] = useState(false);

  const [createCoupon, { loading }] = useMutation(CREATE_COUPON, {
    onCompleted: (data) => {
      setIsOpen(false);
      setCoupons((prevCoupons) => [...prevCoupons, data.createCoupon]);
    },
  });

  const handleAddCoupon = () => {
    createCoupon({
      variables: {
        input: {
          //FIXME: API required fields does not match the ones in the UI
        }
      },
    });
  };

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        className="modal-success"
        buttonLabel="Add Coupon Code"
        buttonStyle={buttonStyle}
        hidden={hidden}
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            .close {
              z-index: 200;
            }          
            .modal-body {
              height: 100%;
              padding: 24px;
            }
          }
          top: 69px;
        `}
      >
        <Head>Add Coupon Code</Head>
        <Container>
          <InputRow>
            <Input
              inputFieldRef={inputRef}
              title="COUPON CODE"
              required
              error={couponCodeError}
              errorMessage="Please enter a valid amount"
              value={couponCode}
              onChange={(e) => {
                setCouponCode(e.target.value);
                setCouponCodeError(false);
              }}
              additionalstyle={`
                width: calc(50% - 8px);

                input {
                  padding-left: 22px;
                }

                .warning {
                  white-space: nowrap;
                }
              `}
            />
            <Input
              title="DISCOUNT"
              error={discountAmountError}
              errorMessage="Please enter a valid amount"
              value={discountAmount}
              onChange={(e) => {
                setDiscountAmount(e.target.value);
                setDiscountAmountError(false);
              }}
              additionalstyle={`
                width: calc(50% - 8px);

                input {
                  padding-left: 22px;
                }

                ::before {
                  content: '$';
                  font-size: 16px;
                  font-weight: 600;
                  position: absolute;
                  color: ${colors.white};
                  left: 12px;
                  top: 32px;
                }

                .warning {
                  white-space: nowrap;
                }
              `}
            />
          </InputRow>
          <TextArea
            title="DESCRIPTION"
            required
            rows={4}
            error={descriptionError}
            value={description}
            onChange={(e) => {
              setDescription(e.target.value);
              setDescriptionError(false);
            }}
            additionalstyle={`
              flex-basis: 100%;
            `}
          />
          <InputRow>
            <div className="datePickerContainer">
              <span>
                START DATE
              </span>
              <DatePicker
                minDate={startDate}
                dateValue={startDate}
                dateOnChange={setStartDate}
                additionalstyle={`
                    width: 100%;
                    min-width: 130px;
                    border: 1px solid ${colors.darkGrey};

                    input {
                      padding-right: 26px;
                    }
                  `}
              />
              <span className="datePlaceHolder">MM/DD/YYYY</span>
            </div>
            <div className="datePickerContainer">
              <span>
                END DATE
              </span>
              <DatePicker
                disabled={!couponExpires}
                minDate={startDate}
                dateValue={endDate}
                dateOnChange={setEndDate}
                additionalstyle={`
                    width: 100%;
                    min-width: 130px;
                    border: 1px solid ${colors.darkGrey};

                    input {
                      padding-right: 26px;
                    }

                    ${
                      !couponExpires
                        ? `
                      border: none;

                      input {
                        padding-left: 0;
                      }

                      button {
                        display: none;
                      }
                    `
                        : null
                    }
                  `}
              />
              <span className="datePlaceHolder">MM/DD/YYYY</span>
            </div>
          </InputRow>
        </Container>
        <Footer>
          <Checkbox
            checked={!couponExpires}
            onChange={() => {
              setCouponExpires(!couponExpires);
            }}
            title={"Coupon code does not expire"}
          />
          <Button
            success
            additionalstyle={`
              width: 84px;
            `}
            onClick={handleAddCoupon}
            data-loading={loading}
          >
            {loading ? null : "Submit"}
          </Button>
        </Footer>
      </MainModal>
    </>
  );
};

export default ModalAddCoupon;
